import { LoadingSpinner } from "../../core/components/LoadingSpinner";
import { useField } from 'formik';
import { ReleaseNoteStyles } from 'legoland-sdk/dist/experimental';
import { Suspense, lazy } from 'react';
import { FormGroup } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
const CommunicationMdEditor = /*#__PURE__*/lazy(() => import( /* webpackChunkName: "comm-md-editor" */"./CommunicationMdEditor"));
export const CommunicationMessageField = ({
  name
}) => {
  const [{
    value
  }, {
    error,
    initialValue,
    touched
  }, {
    setTouched,
    setValue
  }] = useField(name);
  return /*#__PURE__*/_jsx(FormGroup, {
    $alignSelf: "stretch",
    $flex: "auto",
    $gridTemplateRows: "auto auto 1fr auto",
    error: touched && error,
    label: "Message",
    "data-sentry-element": "FormGroup",
    "data-sentry-component": "CommunicationMessageField",
    "data-sentry-source-file": "CommunicationMessageField.tsx",
    children: /*#__PURE__*/_jsx(ReleaseNoteStyles, {
      "data-sentry-element": "ReleaseNoteStyles",
      "data-sentry-source-file": "CommunicationMessageField.tsx",
      "data-sentry-element": "ReleaseNoteStyles",
      children: /*#__PURE__*/_jsx(Suspense, {
        fallback: /*#__PURE__*/_jsx(LoadingSpinner, {}),
        "data-sentry-element": "Suspense",
        "data-sentry-source-file": "CommunicationMessageField.tsx",
        "data-sentry-element": "Suspense",
        children: /*#__PURE__*/_jsx(CommunicationMdEditor, {
          initialValue: initialValue,
          onBlur: () => setTouched(true),
          onChange: setValue,
          value: value,
          "data-sentry-element": "CommunicationMdEditor",
          "data-sentry-source-file": "CommunicationMessageField.tsx",
          "data-sentry-element": "CommunicationMdEditor"
        })
      })
    })
  });
};